import { MosaicTocEntryDto } from "contexts/toc/interface";
import { eHierarchyLevel } from "functions/api/enums";
import { HierarchyChildReadDto } from "functions/api/hierarchy/HierarchyChildReadDto";
import { HierarchyReadDto } from "functions/api/hierarchy/HierarchyReadDto";
import { HierarchyBackupVersionDto } from "functions/api/hierarchy/loadHierarchyVersions";
import { HierarchySearchDto } from "functions/api/hierarchy/searchAllHierarchies";
import { TitlesFootnotesReadDto } from "functions/api/tlfItem/TitlesFootnotesReadDto";
import { TlfItemIndexReadDto } from "functions/api/tlfItem/TlfItemIndexReadDto";
import { TlfItemReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { getHierarchyBaseUrl } from "../hierarchy/getHierarchyBaseUrl";

/**
 * Generates the URL path for a TLF item within a hierarchy.
 *
 * Template TLFs (Corporate, TA, and Project levels) all use a `Template/` path prefix to
 * disambiguate their URLs from the all-dynamic hierarchy routes.
 * Without the prefix, `/:taPrefix/:azsolId/:version` is structurally identical to
 * the Study hierarchy route `/:taPrefix/:projectCode/:studyTag`, and
 * `/:taPrefix/:projectCode/:azsolId/:version` is identical to the Report hierarchy
 * route `/:taPrefix/:projectCode/:studyTag/:reportName`.
 *
 * @param hierarchy - The hierarchy containing the TLF item
 * @param tlfItem - The TLF item to generate the URL for
 * @returns The URL path for the TLF item
 */
export const getTlfUrl = (
  hierarchy:
    HierarchyReadDto | HierarchySearchDto | HierarchyChildReadDto | HierarchyBackupVersionDto,
  tlfItem: TlfItemReadDto | TlfItemIndexReadDto | TitlesFootnotesReadDto | MosaicTocEntryDto,
): string =>
  tlfItem.primaryHierarchyLevel !== eHierarchyLevel.Report
    ? `${getHierarchyBaseUrl(hierarchy)}/Template/${tlfItem.azsolId}/${tlfItem.version}`
    : tlfItem.version === hierarchy.tocMajorVersion && tlfItem.tocNumber
      ? `${getHierarchyBaseUrl(hierarchy)}/${tlfItem.tocNumber}`
      : tlfItem.tocNumber
        ? `${getHierarchyBaseUrl(hierarchy)}/Version/${tlfItem.version}/${tlfItem.tocNumber}`
        : getHierarchyBaseUrl(hierarchy);
